const PlatformType = {
  PLC: "plc",
  PLB: "plb",
  PLCandPLB: "plc-plb",
};

export default PlatformType;
